module.exports = __webpack_public_path__ + "static/sm-blog-darkmode-tc-32f644a9d998aa86ad4e217e7f43dc29.jpg";